/**
 * Soft-reconnect membership helpers.
 * After phone lock / WS drop, lobby removes the player server-side but local
 * roomState often remains — so "we still have roomState" must not skip join-room.
 */

export function normalizeRoomName(name: string | undefined | null): string {
  return (name ?? '').toUpperCase().trim().slice(0, 4);
}

/**
 * Skip reconnect join/get-room-state only when membership is still trusted.
 * When needsRejoin is set (after a real disconnect), always emit.
 */
export function shouldSkipReconnectEmit(options: {
  needsRejoin: boolean;
  savedRoomName: string | null | undefined;
  currentRoomName: string | null | undefined;
}): boolean {
  if (options.needsRejoin) return false;
  const saved = normalizeRoomName(options.savedRoomName);
  const current = normalizeRoomName(options.currentRoomName);
  return !!saved && !!current && saved === current;
}

/** True when local player name appears as a connected entry in room-state players. */
export function isLocalPlayerConnectedInState(
  players: Array<{ name?: string; connected?: boolean }> | undefined,
  localPlayerName: string | null | undefined
): boolean {
  if (!localPlayerName || !Array.isArray(players)) return false;
  return players.some((p) => p?.name === localPlayerName && p.connected !== false);
}
